/**
 * FT10-U16: Supplier Statement Reconciliation (FSD 2.2.2.10). The INT packet spreads
 * `AP_STATEMENT_RECONCILIATION_ROUTES` and adds nav item `ap-statement-reconciliation`
 * (p02). The route's permission is the read endpoints': `ap.report.read` (recording a
 * statement additionally needs `ap.statement_recon.manage`, checked on the action).
 */

import type { RouteRecordRaw } from 'vue-router'

import { STATEMENT_RECON_PERMISSIONS } from './api'

export const AP_STATEMENT_RECONCILIATION_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ap/reports/statement-reconciliation',
    name: 'ap-statement-reconciliation',
    component: () =>
      import('@/modules/ap/reports/statement-reconciliation/StatementReconciliationView.vue'),
    meta: {
      titleKey: 'ap.routeTitles.statementReconciliation',
      permission: STATEMENT_RECON_PERMISSIONS.reportRead,
    },
  },
]
